import { List, Typography } from '@mui/material'
import { FC } from 'react'
import { IconButton } from 'utoniq-ui'

import {
  Maybe,
  TradableUsersConnectionFragment,
} from '@/clients/utoniq-core/schema'
import { BaseLayout } from '@/components/layouts'
import { UserTradeBox, UserTradeBoxSkeleton } from '@/components/organisms'
import { ScrollFetcher } from '@/components/organisms/functionals'
import { useTranslation } from '@/core'

export type TradeRequestUserSelectProps = {
  loading: boolean
  hasNextPage: boolean
  itemId: string
  tradableUsers: Maybe<TradableUsersConnectionFragment>
  onFetchMore: () => Promise<void>
  onClose: () => void
}

export const TradeRequestUserSelect: FC<TradeRequestUserSelectProps> = ({
  loading,
  itemId,
  hasNextPage,
  tradableUsers,
  onClose,
  onFetchMore,
}) => {
  const { t } = useTranslation('tradeRequestUserSelect')
  return (
    <BaseLayout
      margin
      header={{
        left: <IconButton.Back edge="start" size="medium" onClick={onClose} />,
        title: t('title'),
      }}
      sx={{ height: '100%' }}
    >
      {(!!tradableUsers?.edges?.length ||
        (loading && !tradableUsers?.edges?.length)) && (
        <Typography
          sx={{ pt: 2, pb: 3 }}
          variant="body2"
          color="text.secondary"
        >
          {t('yourChoice')}
        </Typography>
      )}
      <ScrollFetcher
        componentProps={{ spacing: 0 }}
        emptyMessage={t('emptyMessage')}
        nodes={tradableUsers?.edges?.map(({ node }, index) => (
          <UserTradeBox userTrade={node} key={index} itemId={itemId} />
        ))}
        component={List}
        loading={loading}
        loadingComponent={
          <List>
            {[1, 2, 3, 4, 5].map(i => (
              <UserTradeBoxSkeleton key={i} />
            ))}
          </List>
        }
        hasNextPage={hasNextPage}
        onFetchMore={onFetchMore}
      />
    </BaseLayout>
  )
}
